import React from 'react';
//import "bootstrap/dist/css/bootstrap.min.css";


const steps = ["Placed", "Accepted", "Ready", "Serviced", "Cancelled"];
const OrderProgressBar = ({orderStatus }) => {
    
    const statusIndex = steps.indexOf(orderStatus);
  
  
    return (
    <>
    <div className="container mt-4">
      <div className="d-flex flex-md-row align-items-center justify-content-between position-relative">
        {steps.map((step, index) => (
          <div key={index} className="text-center flex-grow-1 position-relative">
            {/* Step Connector Line */}
            {index !== 0 && (
              <div
                className={`position-absolute top-50 start-0 translate-middle-y w-100 border ${
                  index <= statusIndex ? "border-success bg-success" : "border-secondary bg-secondary"
                }`}
                style={{ height: "5px", zIndex: "-1" }}
              ></div>
            )}

            {/* Step Circle */}
            <div
              className={`rounded-circle d-flex align-items-center justify-content-center fw-bold text-white mx-auto ${
                index <= statusIndex ? "bg-success" : "bg-secondary"
              }`}
              style={{ width: "30px", height: "30px" }}
            >
              {index + 1}
            </div>

            {/* Step Label */}
            <p
              className={`mt-2 ${
                index <= statusIndex ? "text-success fw-bold" : "text-secondary"
              }`}
              style={{ fontSize: "14px" }}
            >
              {step}
            </p>
          </div>
        ))}
      </div>
    </div>
    </>
  );
}

export default OrderProgressBar;
